import script from "./LegoParts.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegoParts.vue?vue&type=script&setup=true&lang=ts"

export default script